<template>
	<b-col cols="12" sm="6" lg="3" class="text-center">
		<div class="duty-item">
			<div v-animate-onscroll="'animate__animated animate__zoomIn'">
				<FAIcon :icon="itemData.icon" size="2x" class="mb-3" />
			</div>
			<div v-animate-onscroll="'animate__animated animate__fadeInUp'">
				<h3 v-if="itemData.title">{{ itemData.title }}</h3>
				<h4 v-if="itemData.subtitle">{{ itemData.subtitle }}</h4>
				<p v-if="itemData.description" class="text-muted">{{ itemData.description }}</p>
			</div>
		</div>
	</b-col>
</template>

<script>
export default {
	name: 'DutyItem',

	props: {
		itemData: {
			type: Object,
			required: true
		}
	}
}
</script>
